import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";

const ThreatFrameworks = () => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="container mt-4">
      <Accordion activeKey={activeKey}>
        {/* STRIDE Framework */}
        <Card>
          <Card.Header>
            <Button
              variant="link"
              onClick={() => toggleAccordion("0")}
              className="w-100 text-left"
              style={{ fontWeight: "bold", color: "#009fe0" }}
            >
              STRIDE-Modell
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ fontsize: "1rem" }}>
              <p className="text-start">
                Das STRIDE-Modell wurde von Microsoft entwickelt und
                kategorisiert Bedrohungen in sechs Kategorien:
              </p>
              <ul>
                <li className="text-start f-6">
                  <strong>Spoofing:</strong> Identitätsfälschung, z. B. IP- oder
                  Benutzer-Spoofing, um Zugriff zu erlangen.
                </li>
                <li className="text-start">
                  <strong>Tampering:</strong> Unbefugte Manipulation von Daten,
                  etwa das Verändern von Datenbanken.
                </li>
                <li className="text-start">
                  <strong>Repudiation:</strong> Abstreitbarkeit von Aktionen
                  durch fehlende Nachverfolgung, z. B. ohne Logging.
                </li>
                <li className="text-start">
                  <strong>Information Disclosure:</strong> Unautorisierte
                  Offenlegung sensibler Daten, etwa durch SQL-Injection.
                </li>
                <li className="text-start">
                  <strong>Denial of Service (DoS):</strong> Überlastung von
                  Systemen, um legitimen Zugriff zu blockieren.
                </li>
                <li className="text-start">
                  <strong>Elevation of Privilege:</strong> Unbefugte Erweiterung
                  von Berechtigungen, z. B. von Nutzer- zu Administratorrechten.
                </li>
              </ul>
              <p>
                Das STRIDE-Modell hilft dabei, Bedrohungen gezielt zu
                analysieren und Gegenmaßnahmen zu entwickeln. Es wird häufig
                eingesetzt, um Schwachstellen im Systemdesign zu erkennen und zu
                beheben.
              </p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {/* Attack Trees */}
        <Card>
          <Card.Header>
            <Button
              variant="link"
              onClick={() => toggleAccordion("1")}
              className="w-100 text-left"
              style={{ fontWeight: "bold", color: "#009fe0" }}
            >
              Attack Trees (Angriffsbaum-Analyse)
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <p>
                Die Angriffsbaum-Analyse visualisiert potenzielle Angriffspfade
                und Strategien.
              </p>
              <ul>
                <li className="text-start">
                  <strong>Zieldefinition:</strong> Festlegung des Angriffsziels,
                  etwa die Entschlüsselung sensibler Daten.
                </li>
                <li className="text-start">
                  <strong>Angriffspfade:</strong> Visualisierung aller
                  Handlungen, die das Ziel ermöglichen könnten.
                </li>
                <li className="text-start">
                  <strong>Bewertung:</strong> Einschätzung der Pfade
                  hinsichtlich Ressourcen, Machbarkeit und Auswirkungen.
                </li>
              </ul>
              <p>
                Die Angriffsbaum-Analyse bietet Unternehmen eine strukturierte
                und visuelle Methode zur Bedrohungsanalyse, ideal zur
                Entwicklung von Sicherheitsstrategien und zum frühzeitigen
                Erkennen kritischer Angriffswege.
              </p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default ThreatFrameworks;
